// ** React Imports
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

// ** Logic Imports
import { DeleteSkill, GetSkills } from "./skillsapi";
import { GetEmployees } from "screens/Employees/logic/GetEmployees";
import { DeleteTeam, SaveTeams } from "screens/Settings/logic/teams";
import { GetTeams } from "screens/Settings/logic/teams";
import { GetRoles } from './GetRoles';
import { SavePermissions } from "../logic/SavePermissions";
import { GetPermissions } from "./GetPermissions";
import { DeleteRole } from "./DeleteRole";
import { GridColumns } from "./GridColumns";
import { styled, useTheme } from "@mui/material/styles";
import {
  getTermsNConditions,
  saveTermsNConditions,
  deleteTermsNConditions
} from "./TermsNConditionsLogic";
import { useSettingPermission } from "../permissions/SettingPermissions";

// ** Third-Party Imports
import _ from 'lodash';
import dayjs from "dayjs";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { GetOnboardingStatus } from "components/logic/paymentgateway/GetOnboardingStatus";
import { GetSubscriptionDetails } from "components/logic/paymentgateway/getSubscriptionDetails";
import { ConnectExistingStripe, CreateAndConnectStripe, DeleteStripeAccount, GetStripeAccount, GetStripeStatus } from "components/StripeConnect/logic/stripe-api";
import { GetSubscription } from "./GetSubscription";

export const useIndexLogic = (toast) => {
  //#region Permissions
  const { SettingPermissionProps } = useSettingPermission();
  const {
    // Role Permissions
    hasRoleSavePermission,
    hasRoleGetPermission,
    hasRoleDeletePermission,
    hasRolePermsGetPermission,

    // Team Permissions
    hasTeamSavePermission,
    hasTeamGetPermission,
    hasTeamDeletePermission,

    // stripes Permissions
    hasStripeGetPermission,

    // Subscription Permissions
    hasSubscriptionGetPermission,

    // Skill Permissions
    hasSkillSavePermission,
    hasSkillGetPermission,
    hasSkillDeletePermission,

    // CompanySettings Permissions
    hasCompanyGetPermission,

    // TermsAndConditions Permissions
    hasTnCSavePermission,
    hasTnCGetPermission,
    hasTnCDeletePermission,

    // Industry Permissions
    hasIndustrySavePermission,
    hasIndustryGetPermission,
    hasIndustryDeletePermission,
  } = SettingPermissionProps;
  //#endregion Permissions

  //#region Hooks
  const navigate = useNavigate();
  //#endregion

  //#region Constants
  const contentHeightFixed = false;
  const pretabvalue = (window.location.hash).replace('#','') || "1";
  //#endregion End of Constants

  const getInitialTabValue = () => {
    if (hasCompanyGetPermission) return "1";
    if (hasIndustryGetPermission) return "2";
    if (hasRoleGetPermission) return "3";
    if (hasTeamGetPermission) return "4";
    if (hasStripeGetPermission) return "5";
    if (hasSubscriptionGetPermission) return "6";
    if (hasTnCGetPermission) return "7";
    return "1";
  };

  //#region States

  const [loading, setLoading] = useState(true);
  const [collapse, setCollapse] = useState(false);
  const [tabValue, setTabValue] = useState(pretabvalue || getInitialTabValue());
  const [rnpTabValue, setRnpTabValue] = useState("1");
  const [tabTitle, setTabTitle] = useState("Role-Based Access Permissions");
  const [tabSubTitle, setTabSubTitle] = useState(
    "Manage permissions for different roles in the system."
  );
  const [openRoleDlg, setOpenRoleDlg] = useState(false);
  const [roleContent, setRoleContent] = useState({ entity: 'create', title: 'Create New Role' })
  const [openRoleManagement, setOpenRoleManagement] = useState(false);
  const [openTeamDlg, setOpenTeamDlg] = useState(false);
  const [openSkillTypeDlg, setOpenSkillTypeDlg] = useState(false);

  const[skillsList, setSkillsList] = useState([]);
  const [SkillContent, setSkillContent] = useState({entity:'create', title:'Create New Skill Type'});

  const [skill, setSkill] = useState({
    skillID: 0,
    skillName: "",
    isActive: true,
  });
  const theme = useTheme();
  const MySwal = withReactContent(Swal);

  //team states
  const[teamsList, setTeamsList] = useState([]);
  const [team, setTeam] = useState({
    teamID: 0,
    teamName: "",
    teamMembers:[],
    crewLeaderID:0,
    isActive: true,
  });

  const [employeesList, setEmployeesList] = useState([]);
  const [teamcontent, setteamcontent] = useState({entity:'create', title:'Create New Team'});
  const [openSalesTaxDlg, setOpenSalesTaxDlg] = useState(false);
  const [existingRole, setExistingRole] = useState({});
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [permissions, setPermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [initialPermissions, setInitialPermissions] = useState([]);

  // Permission Options Start
  const [configurationOptions, setConfigurationOptions] = useState({});
  const [customerOptions, setCustomerOptions] = useState({});
  const [dashboardOptions, setDashboardOptions] = useState({});
  const [dispatchBoardOptions, setDispatchBoardOptions] = useState({});
  const [employeeOptions, setEmployeeOptions] = useState({});
  const [inventoryOptions, setInventoryOptions] = useState({});
  const [invoiceOptions, setInvoiceOptions] = useState({});
  const [mediaOptions, setMediaOptions] = useState({});
  const [paymentOptions, setPaymentOptions] = useState({});
  const [profileOptions, setProfileOptions] = useState({});
  const [serviceRequestOptions, setServiceRequestOptions] = useState({});
  const [servicesOptions, setServicesOptions] = useState({});
  const [settingsOptions, setSettingsOptions] = useState({});
  
  const [onboardingStatus, setOnboardingStatus] = useState({});
  
  const [calculation, setCalculation] = useState({});
  // Permission Options End

  const [isPermChanged, setIsPermChanged] = useState(false);
  const [stripeStatus, setStripeStatus] = useState(false);

// TermsNConditions

// State setup:
const [tncRows, setTncRows] = useState([]);
const [loadingTnc, setLoadingTnc] = useState(false);
const [openTnCDlg, setOpenTnCDlg] = useState(false);
const [editTnc, setEditTnc] = useState(null); // for editing
const [search, setSearch] = useState("");
const [filterModule, setFilterModule] = useState("all");
const [accountOption, setAccountOption] = useState("");
const [connectOpen,setConnectOpen] = useState(false);
const [stripeAccount, setStripeAccount] = useState({});

const [invoiceDialogOpen, setInvoiceDialogOpen] = useState(false);
const [subscriptionPaymnets, setSubscriptionPayments] = useState([]);

const [openReceipt, setOpenReceipt] = useState(false);

const [historyLoading, setHistoryLoading] = useState(true);


const MODULES = [
  { label: "Invoice", value: "Invoice" },
  { label: "Estimate", value: "Estimate" }
];

  //#endregion end of states
  //#region Handlers and methods

  // Terms and conditions handlers
  // Load T&Cs

  const handleCloseStripeConnect = () => {
    setConnectOpen(false);
  }

  const handleCloseReceipt = () => {
    setOpenReceipt(false);
  }

  const handleOpenReceipt = () => {
    setOpenReceipt(true);
  }

  const handleOpenStripeConnect = () => {
    setConnectOpen(true);
  }
  const getSubscriptionDetails = async () => {
      const response = await GetSubscriptionDetails(navigate);
      if (response && !response.isError) {
        setCalculation(response.result);    
      }
    }

   const getOnboardingStatus = async ()  => {
      try {
        const response = await GetOnboardingStatus(navigate);
        if (response && !response.isError) {
          setOnboardingStatus(response.result);        
        }
      }catch(e){
        console.error("Error fetching onboarding status:", e);
        return;
      }
    }

  const fetchTnC = useCallback(async () => {
    if(!hasTnCGetPermission) return;

    setLoadingTnc(true);
    try {
      const data = await getTermsNConditions(navigate);
      setTncRows(data.map((item) => ({
        id: item.termID,
        termID: item.termID,
        // title: (item.terms || "").split(" ").slice(0, 5).join(" "),
        description: item.terms,
        moduleName: item.moduleName || "",
        createdOn: item.createDate ? dayjs(item.createDate).format("MM/DD/YYYY hh:mm A") : "",
        createdBy: item.createdBy || "",
        lastUpdated: item.modifiedDate ? dayjs(item.modifiedDate).format("MM/DD/YYYY hh:mm A") : '',
        version: 1
      })));
    } catch (err) {
      // toast.error(err.message || 'Failed to fetch Terms & Conditions.', {
      //   position: "top-right",
      //   autoClose: 4000,
      //   theme: "light"
      // });
    } finally {
      setLoadingTnc(false);
    }
  }, [navigate]);

useEffect(() => {
  if(hasTnCGetPermission){
    fetchTnC();
  }
}, [fetchTnC, hasTnCGetPermission]);

useEffect(() => {  
  const fetchSubscriptionPayments = async () => {
    try{
      const response = await GetSubscription();
      const modifiedResponse =  response.map(({ paymentID, ...rest }) => ({
        id: "PAY-"+paymentID.toString().padStart(3, "0"),
        paymentID: paymentID,        
        ...rest  
      }));      
      setSubscriptionPayments(modifiedResponse);  
    }finally{
      setHistoryLoading(false);
    }      
  } 

  if(invoiceDialogOpen){
    fetchSubscriptionPayments();
  }  
},[invoiceDialogOpen])

useEffect(() => {
 if(pretabvalue === "4"){
   const fetchStripeStatus = async () =>{
    const res = await  GetStripeAccount(navigate);
    const status = await GetStripeStatus(navigate);
    if(!status.isError){
     setStripeAccount(status.result);
    }
    if(res && !res.isError){
      setStripeStatus(true);
    }else{
      setStripeStatus(false);
    }
   }

   fetchStripeStatus();
 }
}, [pretabvalue]);

const handleDisconnectStripe = async () => {

  MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: '<span>You won\'t be able to revert this!</span>',
    showCancelButton: true,
    confirmButtonText: 'Yes, disconnect it!',
    cancelButtonText: 'No, keep it',
     width: '390px', // Explicit width control
  padding: '1rem',
    focusConfirm: false,
     showCloseButton: true,
     closeButtonHtml: '&times;', // This is the × symbol
    customClass: {
      popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
          cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
    }
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        // Call your disconnect logic here
         const res = await DeleteStripeAccount(navigate);
         if(!res.isError){
          setStripeStatus(false);        
          toast.success("Stripe account disconnected successfully!", {
            position: "top-right",
            autoClose: 3000,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }else{
          toast.error(res.message || 'Failed to disconnect Stripe account.', {
            position: "top-right",
            autoClose: 4000,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
        
      } catch (err) {
        toast.error(err.message || 'Failed to disconnect Stripe account.', {
          position: "top-right",
          autoClose: 4000,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      }
    }
  });
}

const handleManageStripeAccount = () => {  
  if(stripeStatus){
    // Navigate to Stripe Dashboard
    window.open(stripeAccount?.dashboardUrl || 'https://dashboard.stripe.com', "_blank");
  }else{
    // Open Stripe Connect Dialog
    handleOpenStripeConnect();
  }
}

  const handleExistingStripeConnection = async () => {
    setLoading(true);
    try {
      // Call your backend to create a Stripe account connection
      setAccountOption("existing");
      const response = await ConnectExistingStripe(window.location.origin+'/stripe-connect/success',navigate);

      if(!response.isError){
        const url  = response.result;            
        window.open(url, '_blank'); 
      }else{
        toast.error(response.message || 'An error occurred while connecting to Stripe', {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
      }
           
    } catch (error) {
      console.error('Error connecting Stripe:', error);      
    }finally{
      setLoading(false);
    }
  };
  const handleNewStripeConnection = async () => {
    setLoading(true);
    try {
      setAccountOption("new");
      // Call your backend to create a Stripe account connection
      const response = await CreateAndConnectStripe(window.location.origin+'/stripe-connect/success',navigate);

      if(!response.isError){
        const url  = response.result;            
        window.open(url, '_blank'); 
      }else{
        toast.error(response.message || 'An error occurred while connecting to Stripe', {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
      }      
    } catch (error) {
      console.error('Error connecting Stripe:', error);      
    }finally{
      setLoading(false);
    }
  };

// Open add dialog
const handleOpenTnCDlg = () => {
  setEditTnc(null);
  setOpenTnCDlg(true);
};

// Open edit dialog
const handleEditTnC = (row) => {
  if(!hasTnCSavePermission) return;

  setEditTnc(row);
  setOpenTnCDlg(true);
};

// Delete with confirmation
const handleDeleteTnC = async (row) => {
  if(!hasTnCDeletePermission) return;

  MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: '<span>You won\'t be able to revert this!</span>',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
     width: '390px', // Explicit width control
  padding: '1rem',
    focusConfirm: false,
     showCloseButton: true,
     closeButtonHtml: '&times;', // This is the × symbol
    customClass: {
      popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
      title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
      htmlContainer: 'custom-swal-html',
      confirmButton: 'custom-swal-confirm',
     cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
       closeButton: 'custom-swal-close'
    }
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await deleteTermsNConditions(navigate, row.termID);
        fetchTnC();
        toast.success("Terms & Conditions deleted successfully!", {
          position: "top-right",
          autoClose: 3000,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      } catch (err) {
        toast.error(err.message || 'Failed to delete Terms & Conditions.', {
          position: "top-right",
          autoClose: 4000,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      }
    }
  });
};

// Save handler (for add/edit)
const handleSaveTnC = async (payload) => {

  if(!hasTnCSavePermission) return;

  try {
    await saveTermsNConditions(navigate, payload);
    setOpenTnCDlg(false);
    fetchTnC();
    toast.success("Terms & Conditions saved successfully!", {
      position: "top-right",
      autoClose: 3000,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
    });
  } catch (err) {
    toast.error(err.message || 'Failed to save Terms & Conditions.', {
      position: "top-right",
      autoClose: 4000,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
    });
  }
};

const filteredRows = tncRows.filter(row => {
  if(!hasTnCGetPermission) return;

  if (filterModule !== "all" && row.moduleName !== filterModule) return false;
  if (search.trim()) {
    const q = search.trim().toLowerCase();
    return (
      (row.moduleName && row.moduleName.toLowerCase().includes(q)) ||
      (row.description && row.description.toLowerCase().includes(q))
    );
  }
  return true;
});

// End Terms and Conditons handlers

  const fetchRoles = async (roleId) => {
    if(!hasRoleGetPermission) return;
    
    const response = await GetRoles(roleId, navigate);
    if (!response.isError) {
      const formattedRoles = response.map(role => ({
        id: role.roleID,
        roleID: role.roleID,
        roleName: role.roleName,
        roleType: role.roleType,
      }));
      setRoles(formattedRoles);

      if (formattedRoles.length > 0) {
        if(selectedRole === ''){
          setSelectedRole(formattedRoles[0].roleID);
        }
      }
    } else {
      toast.error(response.message || "Failed to fetch roles", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
    }
  };

  const fetchPermissions = async (roleID) => {
    if(!hasRolePermsGetPermission) return;

    const response = await GetPermissions(roleID, navigate);
    if (!response.isError) {
      const filteredData = response
      .filter(item => item.roleID !== 0 || item.rolePermissionID !== 0)
      .map(({ permissionID, rolePermissionID, isActive }) => ({ 
        permissionID, 
        rolePermissionID,
        isActive,
      }));
      
      setPermissions(response);
      setInitialPermissions(filteredData);
      setSelectedPermissions(filteredData);
    } else {
      toast.error(response.message || "Failed to fetch roles", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
    }
  };

const fetchSkillDetails = async (skillID) => {
  if(!hasSkillGetPermission) return;

  const response = await GetSkills(skillID,navigate);
  if (!response.isError) {
   const modifiedSkills =  response.result.map(({ skillID, createDate, ...rest }) => ({
      id: skillID,        
      createDate: createDate, // Ensure creation date is included
      ...rest  
    }));
    
    // Sort skills by creation date (newest first)
    const sortedSkills = modifiedSkills.sort((a, b) => {
      const dateA = new Date(a.createDate || 0);
      const dateB = new Date(b.createDate || 0);
      return dateB - dateA; // Descending order
    });
    
    setSkillsList(sortedSkills);
  } else {
    toast.error(response.message || "Failed to fetch skill details", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
  }
};

const fetchTeamDetails = async (teamID) => {
  if(!hasTeamGetPermission) return;

  const response = await GetTeams(teamID,navigate);
  
  if (!response.isError) {
   const modifiedTeams =  response.result.map(({ teamID, createDate, ...rest }) => ({
      id: teamID,        
      createDate: createDate, // Ensure creation date is included
      ...rest  
    }));
    
    // Sort teams by creation date (newest first)
    const sortedTeams = modifiedTeams.sort((a, b) => {
      const dateA = new Date(a.createDate || 0);
      const dateB = new Date(b.createDate || 0);
      return dateB - dateA; // Descending order
    });
    
    setTeamsList(sortedTeams);
  } else {
    toast.error(response.message || "Failed to fetch team details", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
  }
};

  const fetchEmployees = async () => {
    try {
      let emp = await GetEmployees(0, navigate);               
      setEmployeesList(emp);                
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }finally {
      setLoading(false); 
    }
  };

  useEffect(() => {
    if(hasSkillGetPermission){
      fetchSkillDetails(0);
    }
    if(hasTeamGetPermission){
      fetchTeamDetails(0);
    }
    fetchEmployees();
    if(hasRoleGetPermission){
      fetchRoles(0);
    }
  }, [hasRoleGetPermission, hasTeamGetPermission, hasSkillGetPermission]);

  useEffect(() => {
    const isEqual = _.isEqual(selectedPermissions, initialPermissions);
    setIsPermChanged(!isEqual);
  }, [selectedPermissions, initialPermissions]);

  useEffect(() => {
    if(selectedRole){
      fetchPermissions(selectedRole);
    }
  }, [selectedRole]);

  useEffect(() => {
    if(permissions && Array.isArray(permissions)){

    // const groupedPermissions = permissions.reduce((acc, permission) => {
    //   const { module } = permission;
    //   if (!acc[module]) {
    //     acc[module] = [];
    //   }
    //   acc[module].push(permission);
    //   return acc;
    // }, {});

    // console.log('groupedPermissions', groupedPermissions)

      const configurationPermissions = permissions.filter(item => item.module === "Configuration");
      const customerPermissions = permissions.filter(item => item.module === "Customer");
      const dashboardPermissions = permissions.filter(item => item.module === "Dashboard" && item.controller !== "Tour");
      const dispatchBoardPermissions = permissions.filter(item => item.module === "DispatchBoard");
      const employeePermissions = permissions.filter(item => item.module === "Employee");
      const inventoryPermissions = permissions.filter(item => item.module === "Inventory");
      const invoicePermissions = permissions.filter(item => item.module === "Invoice");
      const mediaPermissions = permissions.filter(item => item.module === "Media");
      const paymentPermissions = permissions.filter(item => item.module === "Payment");
      const profilePermissions = permissions.filter(item => item.module === "Profile");
      const serviceRequestPermissions = permissions.filter(item => item.module === "ServiceRequest");
      const servicesPermissions = permissions.filter(item => item.module === "Services");
      const SettingsPermissions = permissions.filter(item => item.module === "Settings" && item.action !== 'GetUserPermissions' && item.action !== 'GetUserMenuItems');
      
      setConfigurationOptions(configurationPermissions);
      setCustomerOptions(customerPermissions);
      setDashboardOptions(dashboardPermissions);
      setDispatchBoardOptions(dispatchBoardPermissions);
      setEmployeeOptions(employeePermissions);
      setInventoryOptions(inventoryPermissions);
      setInvoiceOptions(invoicePermissions);
      setMediaOptions(mediaPermissions);
      setPaymentOptions(paymentPermissions);
      setProfileOptions(profilePermissions);
      setServiceRequestOptions(serviceRequestPermissions);
      setServicesOptions(servicesPermissions);
      setSettingsOptions(SettingsPermissions);
    }
  }, [permissions]);

  useEffect(() => {
    getOnboardingStatus();
    getSubscriptionDetails();
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);    
    navigate(`#${newValue}`); // Navigate to the new tab
    if (newValue === "1") {
      setTabTitle("Role-Based Access Permissions");
      setTabSubTitle("Manage permissions for different roles in the system.");
    } else {
      setTabTitle("Teams");
      setTabSubTitle("Create and manage teams or groups.");
    }
  };

  // Roles and Permissions Handlers Start
  const handleRoleFilterChange = (id) => {
    setSelectedRole(id);
  };

  const showConfirmationRoleDelete = (id) => {
    if(!hasRoleDeletePermission) return;

    MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: '<span>You won\'t be able to revert this!</span>',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
     width: '390px', // Explicit width control
  padding: '1rem',
    focusConfirm: false,
     showCloseButton: true,
     closeButtonHtml: '&times;', // This is the × symbol
    customClass: {
      popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
      title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
      htmlContainer: 'custom-swal-html',
      confirmButton: 'custom-swal-confirm',
      cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
       closeButton: 'custom-swal-close'
    }
  }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteRole(id);        
      }
    });
  };
  
  const handleDeleteRole = async (id) => {    
    if(!hasRoleDeletePermission) return;

    try {
      setLoading(true);
      const result = await DeleteRole(id, navigate);
        if (result && !result.isError) {
          fetchRoles(0);                    
          toast.success("Role deleted successfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
               theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
      } else {
          toast.error(result.message || 'Role failed to delete.', {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
                theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
      }
    } catch (error) {
      console.error('Error deleting Role:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRoleEdit = (roleID) => {
    if(!hasRoleSavePermission) return;

    const roleToEdit = roles.find((role) => role.id === roleID);
    if (roleToEdit) {
      setRoleContent({ entity: "edit", title: "Edit Role" });
      setExistingRole({        
        roleID: roleToEdit.roleID,
        roleName: roleToEdit.roleName,
        roleType: roleToEdit.roleType,
      });
      setOpenRoleDlg(true);
    }
  };

  const handleTogglePermission = (event, option) => {
    if(!hasRoleSavePermission) return;

    const isChecked = event.target.checked;
    const { permissionID, rolePermissionID } = option;

    setPermissions(prevPermissions => {
      return prevPermissions.map(permission => 
        permission.permissionID === permissionID
          ? { ...permission, rolePermissionID: isChecked ? 1 : 0, isActive: isChecked ? true : false }
          : permission
      );
    });

    setSelectedPermissions(prevSelected => {
      if (isChecked) {
        const existingIndex = prevSelected.findIndex(
          p => p.permissionID === permissionID
        );
        
        if (existingIndex >= 0) {
          return prevSelected.map(p =>
            p.permissionID === permissionID
              ? { ...p, rolePermissionID, isActive: true }
              : {...p, isActive: true}
          );
        } else {
          return [...prevSelected, { permissionID, rolePermissionID, isActive: true }];
        }
      } else {
        return prevSelected.filter(p => p.permissionID !== permissionID);
      }
    });
  };

  const handleSavePermissions = async () => {
    if(!hasRoleSavePermission) return;

    const Payload = {
      roleID: selectedRole,
      permissions: selectedPermissions,
    }

    try {
      const result = await SavePermissions(Payload, navigate);
      if (result && !result.isError) {
        toast.success("Permissions updated successfully");
        fetchPermissions(selectedRole);
      } else {
        toast.error(result?.message || "Failed to save permissions");
      }
    } catch (error) {
      console.error("Error saving permissions:", error);
      toast.error("An error occurred while saving the permissions");
    }
  };

  const handleRnpTabChange = (event, newValue) => setRnpTabValue(newValue);

  const handleOpenRoleDlg = () => { 
    setRoleContent({ entity: "create", title: "Create New Role" });
    setOpenRoleDlg(true); 
  };
  const handleCloseRoleDlg = () => setOpenRoleDlg(false);

  const handleOpenRoleManagement = () => setOpenRoleManagement(true);
  const handleCloseRoleManagement = () => setOpenRoleManagement(false);
  // Roles and Permissions Handlers End

  const handleSkillEdit = (skillID) => {    
    if(!hasSkillSavePermission) return;

    const skillType = skillsList.find((skill) => skill.id === skillID);
    setSkillContent({entity:'edit', title:'Edit Skill Type'});

    setSkill({
      skillID: skillType.id,
      skillName: skillType.skillName,
      isActive: skillType.isActive, 
    });
    setOpenSkillTypeDlg(true);
  }
  
  const handleTeamEdit = (teamID) => {
    if(!hasTeamSavePermission) return;

    const teamToEdit = teamsList.find((team) => team.id === teamID);
    if (teamToEdit) {
      setteamcontent({ entity: "edit", title: "Edit Team" });
      setTeam({        
        teamID: teamToEdit.id,
        teamName: teamToEdit.teamName,
        teamMembers: Array.isArray(teamToEdit.teamMembers) && teamToEdit.teamMembers.length > 0
        ? teamToEdit.teamMembers.map(emp => emp.employeeID)
        : [],
        crewLeader: teamToEdit.crewLeader || 0,
        isActive: teamToEdit.isActive ?? true,
        crewLeaderID: teamToEdit.crewLeaderID,
        createdBy: teamToEdit.createdBy,
        createDate: teamToEdit.createDate, 
        modifiedBy: teamToEdit.modifiedBy || " ",
        modifiedDate: teamToEdit.modifiedDate,    
      });
      setOpenTeamDlg(true);
    }
  };
 
  const showConfirmationSkillDelete = (id) => {
    if(!hasSkillDeletePermission) return;

       MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: '<span>You won\'t be able to revert this!</span>',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
     width: '390px', // Explicit width control
  padding: '1rem',
    focusConfirm: false,
     showCloseButton: true,
     closeButtonHtml: '&times;', // This is the × symbol
    customClass: {
      popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
      title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
      htmlContainer: 'custom-swal-html',
      confirmButton: 'custom-swal-confirm',
      cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
       closeButton: 'custom-swal-close'
    }
  });
  };
    
  const handleDeleteSkill = async (id) => {    
    if(!hasSkillDeletePermission) return;

    try {
      setLoading(true);
      const result = await DeleteSkill(id, navigate);
        if (result && !result.isError) {
          fetchSkillDetails(0);                    
          toast.success("Skill deleted successfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
               theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
      } else {
          toast.error(result.message || 'Skill failed to delete.', {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
               theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
      }
    } catch (error) {
      console.error('Error deleting Skill:', error);
    } finally {
      setLoading(false);
    }
  };

  const showConfirmationTeamDelete = (id) => {
    if(!hasTeamDeletePermission) return;

      MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: '<span>You won\'t be able to revert this!</span>',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
     width: '390px', // Explicit width control
  padding: '1rem',
    focusConfirm: false,
     showCloseButton: true,
     closeButtonHtml: '&times;', // This is the × symbol
    customClass: {
      popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
      title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
      htmlContainer: 'custom-swal-html',
      confirmButton: 'custom-swal-confirm',
      cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
       closeButton: 'custom-swal-close'
    }
  });
  };
  
  const handleDeleteTeam = async (id) => {    
    if(!hasTeamDeletePermission) return;

    try {
      setLoading(true);
      const result = await DeleteTeam(id, navigate);
        if (result && !result.isError) {
          fetchTeamDetails(0);                    
          toast.success("team deleted successfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
               theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
      } else {
          toast.error(result.message || 'Team failed to delete.', {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
               theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
      }
    } catch (error) {
      console.error('Error deleting Team:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field,value) => {
    setSkill((prevSkill) => ({
      ...prevSkill,
      [field]: value,
    }));
  };

  const handleOpenTeamDlg = () => {
    setOpenTeamDlg(true);
    setteamcontent({entity:'create', title:'Create New Team'});
    setTeam({
      teamID: 0,
      teamName: "",
      teamMembers: [],
      crewLeader: 0,
      isActive: true,
    });
  }
  const handleCloseTeamDlg = () => setOpenTeamDlg(false);
  const handleSaveTeam = () => handleCloseTeamDlg();

  const handleTeamChange = (field, value) => {
    setTeam((prevTeam) => ({
      ...prevTeam,
      [field]: value,
    }));
  }
  
  const handleOpenSkillTypeDlg = () =>{
      setOpenSkillTypeDlg(true);
      setSkillContent({entity:'create', title:'Create New Skill Type'});
      setSkill({
        skillID: 0,
        skillName: "",
        isActive: true,
      });
    }
  const handleCloseSkillTypeDlg = () => setOpenSkillTypeDlg(false);

  const handleOpenSalesTaxDlg = () => setOpenSalesTaxDlg(true);
  const handleCloseSalesTaxDlg = () => setOpenSalesTaxDlg(false);

  // const handleOpenTnCDlg = () => setOpenTnCDlg(true);
  const handleCloseTnCDlg = () => setOpenTnCDlg(false);

  //#endregion end of handlers and methods

  const {
    columnsRoleManagement,
    columnsTeam,
    columnsSkillType,
    columnsSalesTaxRate,
    columnsTermsNConditions,
  } = GridColumns({ handleRoleEdit, showConfirmationRoleDelete, handleTeamEdit, showConfirmationTeamDelete, handleSkillEdit, showConfirmationSkillDelete, handleEditTnC, handleDeleteTnC});

  //#region Props
  const IndexProps = {
    contentHeightFixed,
    setLoading,
    loading,
    tabValue,
    tabTitle,
    tabSubTitle,
    handleTabChange,
    openTeamDlg,
    openSalesTaxDlg,
    openTnCDlg,
    setOpenTeamDlg,  
    setOpenSalesTaxDlg,
    handleOpenTeamDlg,
    handleCloseTeamDlg,
    handleOpenSalesTaxDlg,
    handleCloseSalesTaxDlg,
    handleOpenTnCDlg,
    handleCloseTnCDlg,
    handleSaveTeam,
    columnsTeam,
    columnsSkillType,
    columnsSalesTaxRate,
    columnsTermsNConditions,
    navigate,
    collapse, 
    setCollapse,
    tncRows,
    setTncRows,
    loadingTnc,
    setLoadingTnc,
    editTnc,
    setEditTnc,
    fetchTnC,
    handleEditTnC,
    handleDeleteTnC, 
    handleSaveTnC,    
    search, 
    setSearch,
    filterModule, 
    setFilterModule,
    filteredRows,
    MODULES,
    onboardingStatus,
    calculation,
    stripeStatus,
    handleDisconnectStripe,
    handleNewStripeConnection,
    handleExistingStripeConnection,
    accountOption,
    handleCloseStripeConnect,
    connectOpen,
    handleOpenStripeConnect,
    stripeAccount,
    handleManageStripeAccount,
    subscriptionPaymnets,
    invoiceDialogOpen, 
    setInvoiceDialogOpen,
    handleOpenReceipt,
    handleCloseReceipt,
    openReceipt,
    historyLoading,
    getOnboardingStatus,
  };

  const RoleProps = {
    rnpTabValue,
    handleRnpTabChange,
    openRoleDlg,
    handleOpenRoleDlg,
    handleCloseRoleDlg,
    roleContent,
    openRoleManagement,
    handleOpenRoleManagement,
    handleCloseRoleManagement,
    columnsRoleManagement,
    fetchRoles,
    existingRole,
    roles,
    setRoles,
    selectedRole,
    setSelectedRole,
    permissions,
    setPermissions,
    handleRoleFilterChange,
    handleTogglePermission,
    selectedPermissions,
    setSelectedPermissions,
    configurationOptions,
    employeeOptions,
    customerOptions,
    mediaOptions,
    dispatchBoardOptions,
    serviceRequestOptions,
    invoiceOptions,
    dashboardOptions,
    settingsOptions,
    inventoryOptions,
    paymentOptions,
    profileOptions,
    servicesOptions,
    handleSavePermissions,
    isPermChanged,
  };

  const SkillProps = {
    skill,
    handleChange,
    handleOpenSkillTypeDlg,
    handleClose: handleCloseSkillTypeDlg,
    open: openSkillTypeDlg,
    setOpenSkillTypeDlg,
    SkillContent,
    handleSkillEdit,
    skillsList,
    fetchSkillDetails
  };

  const TeamProps = {
    team,
    handleTeamChange,
    setOpenTeamDlg,
    handleOpenTeamDlg,
    handleTeamEdit,
    handleClose: handleCloseTeamDlg,
    open : openTeamDlg,
    employeesList,
    teamcontent,
    teamsList,
    fetchTeamDetails
  };
  //#endregion end of IndexProps

  return {
    IndexProps,
    RoleProps,
    SkillProps,
    TeamProps,
  };
};
